export default __webpack_public_path__ + "static/media/revealed9.a4477f86.png";